// native
import { Component, ContentChild, Input } from '@angular/core';

// directive
import { DataGridCellTemplateDirective, DataGridFilterCellTemplateDirective } from './grid-templates.directive';

/**
 * Declarative column definition, projected into <app-data-grid>. Mirrors the
 * inputs of <kendo-grid-column> that the app uses.
 */
@Component({
    selector: 'app-data-grid-column',
    template: '',
    standalone: false
})
export class DataGridColumnComponent {
  @Input() field: string;
  @Input() title: string;
  @Input() width: number;
  /** `false` opts the column out of sorting (otherwise inherits the grid). */
  @Input() sortable: boolean;
  /** `false` opts the column out of filtering (otherwise inherits the grid). */
  @Input() filterable: boolean;
  /** Mirrors kendo's `filter="date"` hint; rendering is driven by the projected templates. */
  @Input() filter: 'text' | 'date' | 'numeric' | 'boolean' = 'text';

  @ContentChild(DataGridCellTemplateDirective) cellTemplate?: DataGridCellTemplateDirective;
  @ContentChild(DataGridFilterCellTemplateDirective) filterCellTemplate?: DataGridFilterCellTemplateDirective;

  get isCommand(): boolean { return false; }
}
